import { Component, OnInit, Injectable } from '@angular/core';
import { EnvironmentService } from '../../core/environment/environment.service';
import { ErrorService } from '../error/error.service';


@Component({
  selector: 'app-error-login',
  templateUrl: './error-login.component.html',
  styleUrls: ['./error-login.component.css']
})
@Injectable({
  providedIn: 'root'
})
export class ErrorLoginComponent implements OnInit {

  linkInitialPage :string;

  constructor(private errorService : ErrorService) { }

  ngOnInit() {
    
    this.linkInitialPage= this.errorService.getUrlInitialPage();
  }

}
